import { getGenderNormalized, getISOStringToDate } from 'utils';
import Address from './Address';
import Phone from './Phone';
var Person = /** @class */ (function () {
    function Person(rawPerson) {
        this.id = '';
        this.firstName = '';
        this.middleName = '';
        this.lastName = '';
        this.gender = '';
        this.email = '';
        this.dateOfBirth = null;
        this.address = new Address();
        this.phones = [new Phone()];
        if (!rawPerson)
            return;
        var id = rawPerson.id, firstName = rawPerson.firstName, middleName = rawPerson.middleName, lastName = rawPerson.lastName, gender = rawPerson.gender, dateOfBirth = rawPerson.dateOfBirth, email = rawPerson.email, phones = rawPerson.phones, address = rawPerson.address;
        this.id = id;
        this.firstName = firstName !== null && firstName !== void 0 ? firstName : '';
        this.middleName = middleName !== null && middleName !== void 0 ? middleName : '';
        this.lastName = lastName !== null && lastName !== void 0 ? lastName : '';
        this.gender = getGenderNormalized(gender);
        this.email = email !== null && email !== void 0 ? email : '';
        this.dateOfBirth = getISOStringToDate(dateOfBirth).date;
        this.address = new Address(address);
        this.phones = phones.length
            ? phones
                .slice()
                .sort(function (phone) { return ((phone === null || phone === void 0 ? void 0 : phone.preferred) ? -1 : 1); })
                .map(function (phone) { return new Phone(phone); })
            : [new Phone()];
        this.address = new Address(address);
    }
    return Person;
}());
export default Person;
//# sourceMappingURL=Person.js.map